/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Grid,
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import moment from "moment";
import Parser from 'html-react-parser';

const SearchLanguages = ({ languages, setReloadComp, setSelectedLang, selectedLang, reloadComp }) => {
  return (
    <>
      {languages.length
        ?
        languages.map(lang => (
          <Button
            className={`summary-btn ${selectedLang === lang.type && 'active-btn'}`}
            onClick={() => {
              setReloadComp(reloadComp + 1);
              setSelectedLang(lang.type);
            }}
            key={lang.type}
          >
            {lang.type === 'CN' ? 'CH' : lang.type}</Button>
        ))
        :
        null
      }
    </>)
}

export default function SearchAccordion({ languages, searchLang, toggleDrawer, onCloseDrawer, row, vocabularies }) {

  const curLang = localStorage.getItem("lang") || 'EN';
  const [selectedLang, setSelectedLang] = useState(curLang);
  const [rowDetails, setRowDetails] = useState({});
  const [highlightDetails, setHighlightDetails] = useState({});
  const [reloadComp, setReloadComp] = useState(1);
  const dobMapping = { 'yyyy': 'YYYY', 'mmyyyy': 'MM/YYYY', 'ddmmyyyy': 'DD/MM/YYYY' };

  useEffect(() => {
    setRowDetails(row.scSanctionEntry.entry.languages[selectedLang === 'CN' ? 'CH' : selectedLang]);
    setHighlightDetails(row['@search.highlights']);
  }, [selectedLang])
  let searchingLang = searchLang;
  searchingLang = searchingLang && searchingLang != null ? searchingLang : 'EN';


  let searchFields = {
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/names/name/value`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][0],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/pobs`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][1],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/addresses`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][2],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/comment`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][3],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/biometricData/value`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][4],
    [`scSanctionEntry/entry/languages/${searchingLang}/referenceNumber`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][5],
    [`scSanctionEntry/entry/languages/${searchingLang}/note`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][6],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/documents/docNumber`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][7],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/documents/docType1`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][8],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/documents/docType2`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][9],
    [`scSanctionEntry/entry/languages/${searchingLang}/identity/documents/note`]: vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['highlightFields'][10]
  };

  return (
    <Drawer className="search-drawer" anchor="right" open={toggleDrawer} onClose={onCloseDrawer}>
      <div className="languages-desktop">
        <SearchLanguages
          languages={languages}
          setReloadComp={setReloadComp}
          setSelectedLang={setSelectedLang}
          selectedLang={selectedLang}
          reloadComp={reloadComp}
        />
        {highlightDetails && Object.keys(highlightDetails).length > 0
          ?
          <>
            <div >
              <Accordion className="search-identity-accordion" defaultExpanded>
                <AccordionSummary
                  className="search-highlights"
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                >
                  <h2>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['Highlight']}</h2>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordion-details">
                    {Object.keys(highlightDetails).map((each) => (
                      <div style={{ maxWidth: 550, wordWrap: "break-word" }}>
                        <span> <b>{searchFields[each]} </b></span> :
                        <ul>{
                          highlightDetails[each] ?
                            highlightDetails[each].map((val) => (
                              <li> {Parser(val)} </li>
                            ))
                            : null}
                        </ul>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </>
          :
          null
        }

        {rowDetails && rowDetails.referenceNumber
          ?
          <>
            <div className="ref-id-name">{rowDetails.referenceNumber} -
              {rowDetails.identity && rowDetails.identity.length && rowDetails.identity[0].names
                && rowDetails.identity[0].names.name && rowDetails.identity[0].names.name.length &&
                rowDetails.identity[0].names.name[0].value
                ? rowDetails.identity[0].names.name[0].value : null}
            </div>
          </>
          :
          null
        }
        {reloadComp ? <div>
          <h2>{vocabularies[selectedLang]['new']['main'][3]}</h2>
          {
            rowDetails && rowDetails.identity && rowDetails.identity.length
              ?
              rowDetails.identity.map((identity, index) => (
                <Accordion className="search-identity-accordion">
                  <AccordionSummary
                    className="search-identity"
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <span className={`identity-num ${selectedLang === 'AR' ? 'identity-num-right' : ''}`}>{index + 1}</span>
                    <div style={{ display: "flex", flexDirection: "column", marginLeft: 4 }} >
                      <div>
                        {vocabularies[selectedLang]['new']['identities'][0]}: {identity.type}
                      </div>
                      <div>
                        {vocabularies[selectedLang]['new']['identities'][1]}: {identity.category}
                      </div>
                      <div style={{ maxWidth: 550, wordWrap: "break-word" }}>
                        {vocabularies[selectedLang]['new']['names'][0]}: {(identity.names && identity.names.name && identity.names.name.length) ? identity.names.name[0].value : ""}
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="accordion-details">
                      {identity.names && identity.names.name && identity.names.name.length
                        ?
                        <>
                          <div
                            style={{ textAlign: selectedLang === 'AR' ? 'right' : 'left', fontWeight: "bold", marginTop: 0, marginBottom: 8, }}
                          >
                            {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['names']['title']}
                          </div>

                          <div key={index} className={`${selectedLang === 'AR' ? 'rowReverse' : 'row'}`}>
                            <Grid container>
                              <Grid item xs={8} style={{ wordWrap: "break-word", maxWidth: 500, fontSize: 12, fontWeight: "bold", }}>
                                FULL_NAME
                              </Grid>
                              <Grid item xs={4} style={{ wordWrap: "break-word", maxWidth: 500, fontSize: 12, fontWeight: "bold" }}>
                                SCRIPT
                              </Grid>
                              {identity.names.name.map((name, keyIndex) => <React.Fragment key={keyIndex}>
                                <Grid item xs={8} style={{ wordWrap: "break-word", maxWidth: 500, }}>
                                  {name.value}
                                </Grid>
                                <Grid item xs={4}>
                                  {name.script}
                                </Grid>
                              </React.Fragment>
                              )}
                            </Grid>
                          </div>
                        </>
                        :
                        null
                      }
                      {
                        identity.names && identity.names.nameOrgSpt && identity.names.nameOrgSpt.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 4, marginBottom: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['nameOnOriginScript']['title']}
                            </div>
                            {identity.names.nameOrgSpt.map((name) => (
                              <>
                                <TextField className="mt-15" disabled style={{ width: '70%' }} label={name.nameType} value={name.value} />
                                <TextField className="mt-15" disabled style={{ width: '20%' }} label='script' value={name.script} />
                              </>
                            ))}
                          </>
                          :
                          null
                      }
                      {
                        identity.documents && identity.documents.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['documents']['title']}
                            </div>
                            {
                              identity.documents.map((document, index) => (
                                <div key={index}>
                                  <table>
                                    <tr>
                                      <td><TextField disabled className="mt-5" label='Document Num' value={document.docNumber} /></td>
                                      <td><TextField disabled className="search-tr mt-5" label='Type 1' value={document.docType1 || '-'} /></td>
                                      <td><TextField disabled className="mt-5" label='Type 2' value={document.docType2 || '-'} /></td>
                                    </tr>
                                    <tr>
                                      <td><TextField disabled className="search-tr mt-5" label='Issuing Country' value={document.issuingCountry || '-'} /></td>
                                      <td><TextField disabled className="mt-5" label='Issued Country' value={document.issuedCountry || '-'} /></td>
                                      <td><TextField disabled className="search-tr mt-5" label='Issued City' value={document.issuedCity || '-'} /></td>
                                    </tr>
                                    <tr>
                                      <td><TextField disabled className="search-tr mt-5" label='Issued Date' value={document.issuedDate || '-'} /></td>
                                      <td><TextField disabled className="mt-5" label='Expired Date' value={document.expDate || '-'} /></td>
                                      <td><TextField disabled className="search-tr mt-5" label='Note' value={document.note} /></td>
                                    </tr>
                                  </table>
                                </div>
                              ))
                            }
                          </>
                          :
                          null
                      }
                      {
                        identity.addresses && identity.addresses.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['addresses']['title']}
                            </div>
                            {identity.addresses.map((address, index) => <div key={index}
                              style={{ maxWidth: 550, wordWrap: "break-word" }}
                              className={`${selectedLang === 'AR' ? 'rowReverse' : ''} "summary-address"`}>{address}</div>)}
                          </>
                          :
                          null
                      }

                      {
                        identity.dobs && identity.dobs.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['datesOfBirth']['title']}
                            </div>
                            {identity.dobs.map((dob, index) => <div key={index} className={`${selectedLang === 'AR' ? 'rowReverse' : ''} "summary-address"`}>

                              {
                                dob.dobType && dob.dobType === 'Specific' &&
                                <div>
                                  {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['new']['dates of birth'][0]}:
                                  <span className="dob-date"> {dob.dateFrom ? moment(dob.dateFrom).format(dob.dobSubsetType && dobMapping[dob.dobSubsetType] ? dobMapping[dob.dobSubsetType] : dobMapping['ddmmyyyy']) : '-'}</span>
                                </div>
                              }

                              {
                                dob.dobType && dob.dobType === 'Range' &&
                                <div>
                                  {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['new']['dates of birth'][2]} :
                                  <span className="dob-date">{dob.dateFrom ? moment(dob.dateFrom).format(dob.dobSubsetType && dobMapping[dob.dobSubsetType] ? dobMapping[dob.dobSubsetType] : dobMapping['ddmmyyyy']) : '-'};{dob.dateTo ? moment(dob.dateTo).format(dob.dobSubsetType && dobMapping[dob.dobSubsetType] ? dobMapping[dob.dobSubsetType] : dobMapping['ddmmyyyy']) : '-'}</span>
                                </div>
                              }


                              <div>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['new']['dates of birth'][6]}: {dob.dobAprox ? 'Yes' : 'No'}</div>
                              <div>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['note']}: {dob.note || '-'}</div>
                            </div>)}
                          </>
                          :
                          null
                      }
                      {
                        identity.pobs && identity.pobs.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['placesOfBirth']['title']}
                            </div>
                            {identity.pobs.map((pob, index) => (
                              <div key={index} className={`${selectedLang === 'AR' ? 'rowReverse' : ''}`}
                                style={{ maxWidth: 550, wordWrap: "break-word" }}>
                                {pob}
                              </div>
                            ))}
                          </>
                          :
                          null
                      }
                      {
                        identity.nationalities && identity.nationalities.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>
                              {vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['nationalities']['title']}
                            </div>
                            {identity.nationalities.map((nationality, index) => <p key={index}
                              style={{ maxWidth: 550, wordWrap: "break-word" }}>{nationality}</p>)}
                          </>
                          :
                          null
                      }
                      {
                        identity.entryFeatures && identity.entryFeatures.feature && identity.entryFeatures.feature.length && (identity.entryFeatures.feature[0].featureType || identity.entryFeatures.feature[0].value)
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['features']['title']}</div>
                            {identity.entryFeatures.feature.map((feat) => (
                              feat.featureType || feat.value ?
                                <>
                                  <TextField disabled className="mt-5" label='Type' value={feat.featureType} />
                                  <TextField disabled className="search-tr mt-5" label='Value' value={feat.value} />
                                </>
                                :
                                null
                            ))}
                          </>
                          :
                          null
                      }
                      {
                        identity.titles && identity.titles.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['titles']['title']}</div>
                            {identity.titles.map((title, index) => (
                              <div key={index} className={`${selectedLang === 'AR' ? 'rowReverse' : ''}`}>
                                <TextField className="search-field" disabled value={title} />
                              </div>
                            ))}
                          </>
                          :
                          null
                      }
                      {
                        identity.designations && identity.designations.length
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, }}>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['summarySections']['designations']['title']}</div>
                            {identity.designations.map((designation, index) => (
                              <div key={index} className={`${selectedLang === 'AR' ? 'rowReverse' : ''}`}>
                                <TextField disabled className="search-field mt-5" value={designation} />
                              </div>
                            ))}
                          </>
                          :
                          null
                      }
                      {
                        identity.comment
                          ?
                          <>
                            <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8, textTransform: "capitalize", }}>{vocabularies[selectedLang === 'CH' ? 'CN' : selectedLang]['search']['note']}</div>
                            <div style={{ maxWidth: 550, wordWrap: "break-word" }} dangerouslySetInnerHTML={{ __html: identity.comment }} />
                          </>
                          :
                          null
                      }
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))
              :
              null
          }
        </div>
          :
          null
        }
      </div>
    </Drawer >
  )
}
